var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Gradient",
    "data-name": "Line Gradient",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.35972,
    y1: 31.99739,
    x2: 57.63477,
    y2: 31.99739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd5900"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.13037,45.40186c-1.56882-1.04666-6.31272-4.20848-7.95166-5.30127a2.15931,2.15931,0,0,0-3.33443,1.78424l0,10.603a2.159,2.159,0,0,0,3.3345,1.78412l7.95163-5.30121A2.15873,2.15873,0,0,0,38.13037,45.40186ZM37.021,47.30664l-7.95166,5.30127a.14456.14456,0,0,1-.2251-.12012v-10.603a.13419.13419,0,0,1,.07617-.12745.1386.1386,0,0,1,.14892.00733L37.021,47.06592A.14451.14451,0,0,1,37.021,47.30664ZM8.36279,26.04529V57.02051a2.98744,2.98744,0,0,0,2.98438,2.98388H54.65088a2.987,2.987,0,0,0,2.98389-2.98388V25.91406a1.00006,1.00006,0,0,0-1-1H16.95819l38.325-10.269a1.0053,1.0053,0,0,0,.707-1.22461L54.06055,6.21973A3.0138,3.0138,0,0,0,50.3867,4.09866C37.0445,7.672,21.93864,11.72319,8.58887,15.29834a3.0139,3.0139,0,0,0-2.12106,3.67384ZM23.10724,13.47852l-5.27155,9.13006L11.4361,24.32336l5.27124-9.13Zm9.13245-2.447L26.9682,20.16162l-6.4,1.71484,5.27154-9.13012Zm9.13165-2.44677-5.27106,9.12994-6.39954,1.71478,5.27149-9.13012ZM54.65088,58.00439H11.34717a.98515.98515,0,0,1-.98438-.98388V36.36816h45.272V57.02051A.985.985,0,0,1,54.65088,58.00439Zm.98389-23.63623h-45.272v-7.4541h45.272Zm-1.835-21.396-5.83459,1.56335,4.27106-7.39764ZM50.50391,6.1377l-5.27118,9.13-6.4,1.71484,5.27106-9.13ZM8.49951,17.6958A.99291.99291,0,0,1,9.10645,17.23l4.8684-1.30444L9.7038,23.32318,8.39941,18.45459A.99389.99389,0,0,1,8.49951,17.6958Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppIcon);
export default __webpack_public_path__ + "static/media/ic_app_icon.4160d4266636eb256113dfd46f370d5f.svg";
export { ForwardRef as ReactComponent };